import { render, staticRenderFns } from "./SpreadsheetLinks.vue?vue&type=template&id=1dc57e42&scoped=true&"
import script from "./SpreadsheetLinks.vue?vue&type=script&lang=js&"
export * from "./SpreadsheetLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc57e42",
  null
  
)

export default component.exports